import { z } from 'zod'

import { prebidTimeout } from 'features/globalSetup/forms/Prebid/Defaults/sections/ConsentManagementSection/components/ConsentManagementCommonFields/schema'
import { customPrebidTimeoutEnabled } from 'features/inventory/domain/forms/PrebidStackForm/schema'
import { PageForGeneralForm } from '../GeneralForm/hooks/useGetPage'

export const schema = z.object({
  customPrebidTimeoutEnabled,
  id: z.string(),
  prebidTimeout,
})

export type Schema = z.infer<typeof schema>

export const schemaDefault = ({
  pagePrebidStack,
}: Pick<PageForGeneralForm, 'pagePrebidStack'>): Schema => {
  const { customPrebidTimeoutEnabled, id, prebidTimeout } = pagePrebidStack

  return {
    customPrebidTimeoutEnabled,
    id,
    prebidTimeout,
  }
}
